import React, { useEffect } from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1),
		padding: theme.spacing(1, 1.25),
		background:
			theme.mode === "light"
				? "linear-gradient(135deg, rgba(255,255,255,0.96) 0%, rgba(248,250,252,0.92) 55%, rgba(239,246,255,0.9) 100%)"
				: "linear-gradient(135deg, rgba(15,23,42,0.96) 0%, rgba(17,24,39,0.92) 55%, rgba(30,41,59,0.94) 100%)",
		backdropFilter: "blur(16px)",
		borderBottom: `1px solid ${theme.mode === "light" ? "rgba(148,163,184,0.18)" : "rgba(255,255,255,0.08)"}`,
		height: "76px",
		boxShadow:
			theme.mode === "light"
				? "0 10px 28px rgba(15, 23, 42, 0.06)"
				: "0 10px 28px rgba(2, 6, 23, 0.24)",
		"& .MuiButton-root": {
			minWidth: 42,
			height: 42,
			borderRadius: 14,
			padding: 0,
			marginRight: theme.spacing(0.5),
			background: theme.mode === "light" ? "rgba(15,23,42,0.04)" : "rgba(255,255,255,0.06)",
			border: `1px solid ${theme.mode === "light" ? "rgba(148,163,184,0.18)" : "rgba(255,255,255,0.08)"}`,
		},
		[theme.breakpoints.down("sm")]: {
			flexWrap: "wrap",
			height: 'max-content',
			padding: theme.spacing(1),
		},
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {

		history.push("/tickets");
	};

	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Escape") {
	// 			handleBack();
	// 		}
	// 	};
	// 	document.addEventListener("keydown", handleKeyDown);
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown);
	// 	};
	// }, [history]);

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					square
					className={classes.ticketHeader}
				>
					<Button color="primary" onClick={handleBack}>
						<ArrowBackIos />
					</Button>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
